import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import Candidate from "../apiResources/Candidate";
import CurrentUser from "../apiResources/CurrentUser";
import CandidateForm from "./CandidateForm";
import { FormError } from "./library/Form";
import {
  Modal,
  ModalBackground,
  ModalContent,
  ModalClose,
  ModalHeading,
} from "./library/Modal";

const CandidateCreateModal = (props: Props) => {
  const { isOpen, onDismiss, onSuccess } = props;
  const [formError, setFormError] = useState("");

  const saveCandidate = async (values) => {
    setFormError(null);
    const userResponse = await CurrentUser.first();

    const user = userResponse.data;

    const candidate = new Candidate({
      ...values,
      recruiterId: user.companyId,
      recruiterUserId: user.id,
    });

    try {
      const success = await candidate.save({ with: "recruiter" });

      if (success) {
        // We re-request the candidate here because we need it's relations.
        const response = await Candidate.includes({
          recruiter: "currency",
        }).find(candidate.id);

        onSuccess(response.data);
      } else {
        return candidate;
      }
    } catch (err) {
      setFormError("😬 Uh oh, something went wrong there!");
      Sentry.captureException(err);
    }

    return null;
  };

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <ModalBackground onClick={onDismiss} />
      <ModalContent>
        <ModalHeading>New Candidate</ModalHeading>
        {formError && <FormError>{formError}</FormError>}
        <CandidateForm onSubmit={saveCandidate} />
        <ModalClose onClick={onDismiss} aria-label="Close candidate modal" />
      </ModalContent>
    </Modal>
  );
};

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  onSuccess: (candidate: Candidate) => void;
};

export default CandidateCreateModal;
